import styled, { StyledComponent } from 'styled-components';

interface TagKeyValueWrapperProps {
  isDragging?: boolean;
}

export const TagKeyValueWrapper: StyledComponent<
  'div',
  any,
  TagKeyValueWrapperProps
> = styled.div<TagKeyValueWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: 52px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-left: 12px;
  background: ${(props) => (props.isDragging ? '#f2f6ff' : '#fff')};

  &:hover {
    background: #f2f6ff;
  }
`;

export const PlaceholderBox: StyledComponent<'div', any> = styled.div`
  width: 20px;
`;

export const DeleteButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 11px;
`;
